module.exports = __webpack_public_path__ + "img/little-witch-preview.4135fc37.png";